<template>
    <span class="msgbl-text-label"><slot /></span>
</template>

<script>
export default {
    name: 'MsgblTextLabel'
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';

.msgbl-text-label {
  color: $grey-color-6;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.5;

  &:not(:last-child) {
    margin-inline-end: 5px;
  }
}
</style>
